export default __webpack_public_path__ + "resources/icons/n441-04db.png";